module.exports = __webpack_public_path__ + "img/gun.water.f7f8c1c8.png";